export default __webpack_public_path__ + "static/media/linguistics.1e823303.png";